import styled from 'styled-components';

export const Container = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;
